import * as React from "react";
import { DirectDebitMethod } from "../../../../../../../Wrap/Constants/Enums/Domain/DirectDebitMethod";
import { BankAccountInstruction } from "../../../../../../../Wrap/Models/Domains/Instructions/BankAccountInstruction";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { GiaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { WrapCashContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/WrapCash/WrapCashContributionModel";
import { IsaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel";
import { MultiDownloadButton } from "../../../../../../Shared/DownloadButton/MultiDownloadButton";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { DocumentsHelper } from "../../../PortfolioDashboard/Components/Document/Resource/DocumentsHelper";
import { processTypeEnum } from "../../Resource/Contents";

interface IDirectDebitInstructionProps extends IProcessComponentProps {
    data:
        | ApplyModel
        | GiaContributionModel
        | IsaContributionModel
        | PensionContributionModel
        | WrapCashContributionModel;
    processType: processTypeEnum;
    needGoToDlu: boolean;
    selectAll: boolean;
    hideCheckBox?: boolean;
    triggerred: number;
    clAccountId?: string;
    onTasksForEsign?: (newTask) => void;
}

interface IDirectDebitInstruction {}

export class DirectDebitInstruction extends ProcessComponent<IDirectDebitInstructionProps, IDirectDebitInstruction> {
    constructor(props: IDirectDebitInstructionProps) {
        super(props);
        this.state = {};
    }

    private useBankAccount(bankAccountNubmer: string): boolean {
        const { data, processType } = this.props;
        if (processType == processTypeEnum.SinglePaymentTransfer ||
            processType == processTypeEnum.RegularPayment ||
            processType == processTypeEnum.topUpWithITFLS) {
            return this.useBankAccountInPayment(
                (data as
                    | GiaContributionModel
                    | IsaContributionModel
                    | PensionContributionModel
                    | WrapCashContributionModel)?.Contribution,
                bankAccountNubmer
            );
        } else if (
            processType == processTypeEnum.NewBusiness ||
            processType == processTypeEnum.NewBusinessExistingClient
        ) {
            return (
                this.useBankAccountInPayment((data as ApplyModel)?.GiaModel, bankAccountNubmer) ||
                this.useBankAccountInPayment((data as ApplyModel)?.IsaModel, bankAccountNubmer) ||
                this.useBankAccountInPayment((data as ApplyModel)?.PensionApply, bankAccountNubmer) ||
                this.useBankAccountInPayment((data as ApplyModel)?.WrapCashModel, bankAccountNubmer)
            );
        }
    }

    private useBankAccountInPayment(model: any, bankAccountNumber: string): boolean {
        return (
            model?.ClientSinglePayment?.BankAccountNumber == bankAccountNumber ||
            model?.ThirdPartySinglePayment?.BankAccountNumber == bankAccountNumber ||
            model?.EmployerSinglePayment?.BankAccountNumber == bankAccountNumber ||
            model?.ClientRegularPayment?.BankAccountNumber == bankAccountNumber ||
            model?.ThirdPartyRegularPayment?.BankAccountNumber == bankAccountNumber ||
            model?.EmployerRegularPayment?.BankAccountNumber == bankAccountNumber
        );
    }

    private needDDIBankAccountsInstructions(): BankAccountInstruction[] {
        return (this.props.data?.BankAccountInstructions || []).filter(
            (bank) =>
                bank.NominatedForDirectDebit == true &&
                bank.DirectDebitMethod == DirectDebitMethod.Paper &&
                this.useBankAccount(bank.AccountNumber)
        );
    }

    private displayDDI(): boolean {
        if (this.props.needGoToDlu) {
            return false;
        }
        return this.needDDIBankAccountsInstructions().length > 0;
    }

    render() {
        const { processType, data } = this.props;
        const props = {
            triggerred: this.props.triggerred,
            isSelectedAll: this.props.selectAll,
        };
        const params = getQueryParameters();
        const customerid = params["customerid"];
        const claccountid = this.props.clAccountId;
        const instructionId = params["id"];
        const headAccountHierarchyId = params["hierarchyid"];
        return (
            <>
                {this.displayDDI() && (
                    <>
                        {this.needDDIBankAccountsInstructions().map((bank) => {
                            return (
                                <MultiDownloadButton
                                    triggerAuto
                                    {...props}
                                    data={null}
                                    onChange={() => {}}
                                    onRef={(ref) => this.appendChild(ref)}
                                    fileName={`Direct Debit Instruction - ${bank.AccountNumber}`}
                                    request={DocumentsHelper.getTaskRequestForDirectDebitInstruction(
                                        processType == processTypeEnum.NewBusinessExistingClient
                                            ? data?.OwnerHierarchyId
                                            : instructionId,
                                        customerid,
                                        claccountid,
                                        headAccountHierarchyId,
                                        processType,
                                        0,
                                        bank.Id
                                    )}
                                    hideCheckbox={this.props.hideCheckBox}
                                    selectedAccount={headAccountHierarchyId}
                                    callBack={(taskRequestId: string) => {
                                        if (this.props.onTasksForEsign) {
                                            this.props.onTasksForEsign({
                                                fileName: `Direct Debit Instruction - ${bank.AccountNumber}`,
                                                taskRequestId: taskRequestId,
                                            })
                                        }
                                    }}
                                />
                            );
                        })}
                    </>
                )}
            </>
        );
    }
}
